const jobs = [
	{
		title: 'Junior Fullstack Web Developer',
		company: 'Xtended Gaming',
		location: "Saint Julian's, Malta",
		period: '09/2023 – Present',
		current: true,
		bullets: [
			'Worked with the Microsoft Azure Pipeline',
			'Developed in C# and React',
			'Configured CI/CD pipelines to ensure proper code deployment',
			'Contributed to Docker Images to help build pipeline agents',
			'Gained experience in a professional development environment and agile workflows',
			'Collaborated with a team of developers to maintain and improve the company website and internal tools',
			'Worked with Phaser.js to create casino games for the website',
		],
	},
	{
		title: 'System Integrator',
		company: 'AIS Technology',
		location: 'Bulebel, Malta',
		note: 'Apprenticeship',
		period: '04/2022 – 06/2023',
		bullets: [
			'Maintenance of computers and hardware',
			'Created websites, web apps and applications',
			'Developed key professional skills throughout the apprenticeship',
		],
	},
	{
		title: 'Web Developer Intern',
		company: 'Malta Lab Network',
		location: 'Msida, Malta',
		period: '07/2020 – 09/2020',
		bullets: [
			'Refactored a legacy website alongside another student and senior developers',
		],
	},
	{
		title: 'Office Intern',
		company: 'Arts Council Malta',
		location: 'Valletta, Malta',
		period: '07/2019 – 09/2019',
		bullets: [
			'Supported employees with office operations using Microsoft Office applications',
		],
	},
];

export default function WorkExperience() {
	return (
		<div>
			{jobs.map((job, i) => (
				<div key={i} className="work-item">
					<div className="work-timeline">
						<div className={`work-dot ${job.current ? 'current' : 'past'}`} />
						{i < jobs.length - 1 && <div className="work-line" />}
					</div>
					<div className="work-content">
						<div className="work-header">
							<span className="work-title">{job.title}</span>
							{job.current && <span className="current-badge">Current</span>}
						</div>
						<p className="work-company">
							{job.company}
							{job.note && (
								<span style={{ color: 'var(--text-muted)' }}>
									{' '}
									· {job.note}
								</span>
							)}
						</p>
						<p className="work-period">
							{job.period}
							{job.location ? ` · ${job.location}` : ''}
						</p>
						<ul className="work-bullets">
							{job.bullets.map((b, j) => (
								<li key={j} className="work-bullet">
									<span className="work-bullet-arrow">›</span>
									{b}
								</li>
							))}
						</ul>
					</div>
				</div>
			))}
		</div>
	);
}
